import Icon from '../components/Icon.vue'

Icon.register({
  briefcase: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M320 336v-48h192v144c0 25.6-22.4 48-48 48h-416c-25.6 0-48-22.4-48-48v-144h192v48c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16zM464 128c25.6 0 48 22.4 48 48v80h-512v-80c0-25.6 22.4-48 48-48h80v-48c0-25.6 22.4-48 48-48h160c25.6 0 48 22.4 48 48v48h80zM320 128v-32h-128v32h128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/briefcase.js
// module id = 1118
// module chunks = 0